import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	whoCanAccessProjectWhatRoles: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	whyUserCannotViewEditIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	whoHasProjectAdminOrManageSprintsPermissions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	whoCanAccessProjectWhatRoles: {
		defaultMessage: 'Who can access this project and what roles do they have?',
		description: 'Rovo permissions prompt',
		id: 'ai-rovo.permissions.who-can-access-project-what-roles',
	},
	whyUserCannotViewEditIssues: {
		defaultMessage: "Why can't a user view or edit issues in this project?",
		description: 'Rovo permissions prompt',
		id: 'ai-rovo.permissions.why-user-cannot-view-edit-issues',
	},
	whoHasProjectAdminOrManageSprintsPermissions: {
		defaultMessage: 'Who has project admin or sprint management permissions?',
		description: 'Rovo permissions prompt',
		id: 'ai-rovo.permissions.who-has-project-admin-sprint-management-permissions',
	},
});
export default messages;
